module.exports = __webpack_public_path__ + "485bdedca9f3fe2f2cdd9ce22a9710e7.png";